import { ARABIC_LOCALE } from '@/constants/i18n';

/** Arabic glyphs must remain in whole-word shaping runs during SplitText reveals. */
export function shouldRevealHeadlineByWord(): boolean {
  return document.documentElement.lang === ARABIC_LOCALE;
}
